module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/kate-koreneva-avatar-17dd4f3b4e7961824b8e5c3a6ecc8d03.jpg";